import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-3 flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Редактирование РПП",
    loading: _ctx.state.is_loading,
    "confirm-button-text": "Сохранить",
    onConfirm: _ctx.editRPP,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        value: _ctx.state.act_number,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.act_number) = $event)),
        "is-invalid": _ctx.state_form$.act_number.$error,
        "validation-errors": _ctx.state_form$.act_number.$errors,
        placeholder: "Номер АВР",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.act_date,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.act_date) = $event)),
        "is-invalid": _ctx.state_form$.act_date.$error,
        "validation-errors": _ctx.state_form$.act_date.$errors,
        placeholder: "Дата АВР",
        type: "date",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.pbs_date,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pbs_date) = $event)),
        "is-invalid": _ctx.state_form$.pbs_date.$error,
        "validation-errors": _ctx.state_form$.pbs_date.$errors,
        placeholder: "Дата РПП",
        type: "date",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        placeholder: "Статья ДДС",
        "is-invalid": _ctx.state_form$.cash_flow_id.$error,
        "validation-errors": _ctx.state_form$.cash_flow_id.$errors,
        loading: _ctx.data_state.cash_flows.is_loading,
        failed: _ctx.data_state.cash_flows.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.cash_flows.list,
        value: _ctx.state.cash_flow_id,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cash_flow_id) = $event)),
        "infinite-scroll": "",
        searchable: false,
        onRefresh: _ctx.loadCashFlows,
        class: "mt-3"
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Компания",
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        "is-invalid": _ctx.state_form$.company_id.$error,
        "validation-errors": _ctx.state_form$.company_id.$errors,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.carriers.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
        onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
        onSearch: _ctx.searchCarriers,
        onOptionBySearch: _ctx.unshiftFindedCarrier
      }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onSearch", "onOptionBySearch"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_checkbox, {
          label: "Добавить КПН (6%)",
          value: _ctx.state.with_income_tax,
          "onUpdate:value": [
            _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.with_income_tax) = $event)),
            _ctx.onChangeTax
          ]
        }, null, 8, ["value", "onUpdate:value"]),
        (_ctx.state.with_income_tax)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              label: "Добавить 12%",
              class: "ml-3",
              value: _ctx.state.with_nds_tax,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.with_nds_tax) = $event)),
              "return-integer": ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "onConfirm", "onCancel"]))
}